import { App } from "./app";
import { RouteEntry } from "./core";

export const routerConfiguration: RouteEntry[] = [
  {
    path: "/",
    component: App,
  },
];
